export const printProbability = (proba) => {
  return `${Math.floor(proba * 100)} %`;
};
